import { render, staticRenderFns } from "./FlightInfoPopover.vue?vue&type=template&id=b563ad9c&"
import script from "./FlightInfoPopover.vue?vue&type=script&lang=js&"
export * from "./FlightInfoPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports